export const BaseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : '';
export const ModelBaseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:5005' : '';

//echart network company colors
export const COLORS = [
    // '#2196F3',
    '#4CAF50',
    '#03A9F4',
    // '#8BC34A',
    '#3F51B5',
    '#F44336',
    '#00BCD4',
    '#E91E63',
    '#673AB7',
    // '#CDDC39',
    '#FF9800',
    // '#FF5722',
    '#FF5722',
    '#E040FB',
    '#7C4DFF',
    '#536DFE',
    '#448AFF',
    '#40C4FF',
    '#18FFFF',
    '#64FFDA',
    '#69F0AE',
    '#B2FF59',
    '#EEFF41',
    '#FFFF00',
    '#FFD740',
    '#FFAB40',
    '#00C853',
    '#FFD600',
    '#FFAB00',
    '#FF9100',
    '#FFEA00',
    '#76FF03',
    '#1DE9B6',
    '#00E5FF',
    '#00B0FF',
    '#1976D2',
    '#E040FB',
]

//echart heatmap cluster colors
export const CLUSTERCOLORS = [
    '#84FFFF', '#FFFF8D', '#FF80AB', '#A7FFEB', '#FF9E80', '#B388FF', '#FF8A80'
]

//echart heatmap cluster colors 2Y
export const CLUSTERCOLORS2Y = [
    '#F8BBD0', '#FFE0B2', '#E1BEE7', '#F0F4C3', '#C5CAE9', '#C8E6C9', '#B2EBF2'
]

export const SEGLABELNAME = {
    SEGMENT_L: "Segment",
    SEGMENT_M: "Tech Segment",
    SEGMENT_S: "IQVIA Segment",
};

export const strPhaseArr = ['Early Phase 1', 'Phase 1', 'Phase 1/Phase 2', 'Phase 2', 'Phase 2/Phase 3', 'Phase 3', 'Phase 4', 'N/A', '-']
export const strPhaseArrApi = ['EARLY_PHASE1', 'PHASE1', 'PHASE1/PHASE2', 'PHASE2', 'PHASE2/PHASE3', 'PHASE3', 'PHASE4', 'NA', '-']

// Maps DB subscribe_plan / role_name ("Level 1" ~ "Level 5") to user-facing plan label.
export const PLAN_LABEL: Record<string, string> = {
    'Level 1': 'Pilot Plan',
    'Level 2': 'Entry Plan',
    'Level 3': 'Innovation Suite Plan',
    'Level 4': 'Initiative Plan',
    'Level 5': 'Strategic Investment Plan',
};